export default "__VITE_ASSET__CY7aSCpo__"